import {Button, Image, Select} from 'antd';
import PropTypes from 'prop-types';
import {useState} from 'react';
import Masonry from 'react-masonry-css';

const {Option} = Select;

const Projects = ({data}) => {
  const [filter, setFilter] = useState('Residential');
  const [sectionFilter, setSectionFilter] = useState('all');

  if (!data || !data.projects) {
    return <div className={'text-center'}>Loading...</div>;
  }

  const filteredProjects = data.projects.filter(project =>
    project.tags?.includes(filter),
  );

  const filters = [
    {label: 'Residential', value: 'Residential'},
    {label: 'Commercial', value: 'Commercial'},
  ];

  const breakpointColumnsObj = {
    default: 3,
    1100: 2,
    700: 2,
    500: 1,
  };

  return (
    <div className={'w-full flex justify-center items-center lg:px-20 px-4 pt-4 bg-primary-950'}>
      <div className={'max-w-7xl w-full'}>

        <h1 className={'lg:text-5xl text-3xl font-bold mb-2 text-secondary-300'}>
          Crafting Exceptional Spaces
        </h1>

        <div className={'flex flex-wrap mb-6 mt-8 justify-center'}>
          {filters.map(item => (
            <Button
              key={item.value}
              onClick={() => {
                setFilter(item.value);
                setSectionFilter('all'); 
              }}
              type={filter === item.value ? 'primary' : 'default'}
              className={'mr-2 mb-2 lg:w-48 h-14 text-lg font-semibold'}
            >
              {item.label}
            </Button>
          ))}
        </div>

        {/* Projects */}
        <div className={'flex flex-wrap justify-center'}>
          {filteredProjects.map(project => {

            const sectionKeys = project.sections
              ? Object.keys(project.sections)
              : [];

            return (
              <div
                key={project.id}
                className={'lg:m-4 w-full rounded-3xl bg-primary-300 lg:px-8 px-5 lg:py-8 py-6'}
              >
                <h2 className={'lg:text-4xl text-2xl font-bold mb-6 text-secondary-600'}>
                  {project.name}
                </h2>

                {project.sections && (
                  <div className={'mb-6'}>
                    <Select
                      value={sectionFilter}
                      onChange={value => setSectionFilter(value)}
                      className={'w-48 h-10 font-semibold'}
                      dropdownStyle={{fontWeight: 600}}
                      style={{fontWeight: 600}}
                    >
                      <Option value={'all'}>
                        <span className={'font-semibold text-sm'}>All Sections</span>
                      </Option>

                      {sectionKeys.map(section => (
                        <Option key={section} value={section}>
                          <span className={'font-semibold text-sm capitalize'}>
                            {section}
                          </span>
                        </Option>
                      ))}
                    </Select>
                  </div>
                )}

                {project.sections &&
                  Object.entries(project.sections)
                    .filter(([sectionName]) =>
                      sectionFilter === 'all'
                        ? true
                        : sectionName === sectionFilter,
                    )
                    .map(([sectionName, images]) => (
                      <div key={sectionName} className={'mb-10'}>
    
                        {sectionFilter === 'all' && (
                          <h3 className={'text-2xl font-semibold mb-4 capitalize text-secondary-400'}>
                            {sectionName}
                          </h3>
                        )}

                        <Masonry
                          breakpointCols={breakpointColumnsObj}
                          className={'flex'}
                          columnClassName={'lg:pl-4 lg:mr-4 mr-2'}
                        >
                          {images.map((photo, index) => (
                            <Image
                              key={index}
                              src={photo}
                              alt={sectionName}
                              className={'mb-4 lg:rounded-xl rounded-lg'}
                            />
                          ))}
                        </Masonry>

                      </div>
                    ))}

                {/* ✅ CASE 2: Normal gallery (Commercial) */}
                {!project.sections && project.heroPhotos && (
                  <Masonry
                    breakpointCols={breakpointColumnsObj}
                    className={'flex'}
                    columnClassName={'lg:pl-4 lg:mr-4 mr-2'}
                  >
                    {project.heroPhotos.map((photo, index) => (
                      <Image
                        key={index}
                        src={photo}
                        alt={project.name}
                        className={'mb-4 lg:rounded-xl rounded-lg'}
                      />
                    ))}
                  </Masonry>
                )}

              </div>
            );
          })}
        </div>

      </div>
    </div>
  );
};

Projects.propTypes = {
  data: PropTypes.shape({
    projects: PropTypes.array,
  }),
};

export default Projects;
